import React from 'react';
import PropTypes from 'prop-types';

import TabsSelectorUI5 from "core/gd-components/tabs-selector/tabs-selector-ui5";

export default class AutoDistributionOptions extends React.Component {

    static props = {
        value: PropTypes.object,

        disabled: PropTypes.bool,

        onSelect: PropTypes.func,
    }

    onChange = (id) => {
        if (this.props.onSelect) {
            this.props.onSelect(id);
            this.forceUpdate();
        }
    }

    render() {

        const autoDistributionOption = (id) => ({
            value   : id,
            icon    : gd.const.timeline.timeAllocation.autoDistributionTypeIcon[id]
        });

        const autoDistributionOptions = [
            autoDistributionOption(gd.const.timeline.timeAllocation.autoDistributionType.FRONT_LOAD),
            autoDistributionOption(gd.const.timeline.timeAllocation.autoDistributionType.EVENLY),
            autoDistributionOption(gd.const.timeline.timeAllocation.autoDistributionType.BACK_LOAD),
        ];

        return (
            <>
                <TabsSelectorUI5 options    = {autoDistributionOptions}
                                 selectedId = {this.props.value}
                                 disabled   = {this.props.disabled}
                                 onChange   = {this.onChange}/>
                <div className="ui5-txt-not-important-tiny m-l-10">{gd.const.timeline.timeAllocation.autoDistributionTypeLabel[this.props.value]}</div>
            </>
        )
    }
}